// Shared leases deduplicate pending loads and protect textures still used by materials.
export class TexturePool {
    constructor({ maxEntries = 16, maxBytes = 32 * 1024 * 1024 } = {}) {
        this.entries = new Map();
        this.maxEntries = maxEntries;
        this.maxBytes = maxBytes;
        this.tick = 0;
    }

    acquire(key, load) {
        let entry = this.entries.get(key);
        if (!entry) {
            entry = { users: 0, used: 0, texture: null, bytes: 0 };
            this.entries.set(key, entry);
            entry.promise = Promise.resolve().then(load).then(texture => {
                entry.texture = texture;
                entry.bytes = (texture.image?.width || 256) * (texture.image?.height || 256) * 4 * 4 / 3;
                this.prune();
                return texture;
            }).catch(error => {
                if (this.entries.get(key) === entry) this.entries.delete(key);
                throw error;
            });
        }
        entry.users += 1;
        entry.used = ++this.tick;
        let released = false;
        return {
            promise: entry.promise,
            release: () => {
                if (released) return;
                released = true;
                entry.users -= 1;
                entry.used = ++this.tick;
                this.prune();
            },
        };
    }

    prune() {
        let bytes = Array.from(this.entries.values()).reduce((total, entry) => total + entry.bytes, 0);
        const idle = Array.from(this.entries.entries())
            .filter(([, entry]) => entry.users === 0 && entry.texture)
            .sort((a, b) => a[1].used - b[1].used);
        for (const [key, entry] of idle) {
            if (this.entries.size <= this.maxEntries && bytes <= this.maxBytes) break;
            this.entries.delete(key);
            bytes -= entry.bytes;
            entry.texture.dispose();
        }
    }
}
